import { render, staticRenderFns } from "./UgiHistoryBar.vue?vue&type=template&id=101e9a20&"
import script from "./UgiHistoryBar.vue?vue&type=script&lang=js&"
export * from "./UgiHistoryBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports